import { defineNuxtPlugin } from '#app'
import { useToast } from '#imports'

export default defineNuxtPlugin(() => {
  const toast = useToast()

  return {
    provide: {
      toast
    }
  }
})
